import { PropsWithChildren } from 'react';
import styles from './styles.module.scss';
import { LastMatchesProps } from './props';
import { AnimatePresence } from 'framer-motion';
import Link from '../../Link';
import games from '@/constants/games';
import useTranslation from 'next-translate/useTranslation';
import { GameID } from '@/enums/gameId';
import { ToolTip } from '@starsoft/common/components';

export default function LastMatches({
  link,
  gameId,
  children,
  isBackgroundPaper,
  modal,
  customPosition,
}: PropsWithChildren<LastMatchesProps>) {
  const game = games.get(gameId?.toString() ?? '');
  const { t } = useTranslation('common');

  function getTooltipLabel() {
    switch (gameId?.toString()) {
      case GameID.Crash?.toString():
      case GameID.Slide?.toString():
      case GameID.Frost?.toString():
      case GameID.CrashTrenball?.toString():
      case GameID.Double?.toString():
        return 'see_last_rounds';
      case GameID.Mines?.toString():
      case GameID.Dice?.toString():
      case GameID.Tower?.toString():
      case GameID.Coinflip?.toString():
      case GameID.Limbo?.toString():
      case GameID.Splash?.toString():
        return 'see_last_bets';
    }
  }

  return (
    <div
      className={`${styles.container} ${customPosition ? styles['container--absolute'] : ''}`}
    >
      <div className={styles.container__list}>
        <AnimatePresence mode="sync">{children}</AnimatePresence>
      </div>

      <ToolTip titleComponent={<div>{t(getTooltipLabel())}</div>}>
        <Link
          href={link}
          modal={modal}
          className={`${styles.container__link} ${isBackgroundPaper ? styles['container__link--paper'] : ''}`}
        >
          <i className={game?.icon} />
        </Link>
      </ToolTip>
    </div>
  );
}
